(function () {
  var IMAGE_SLIDE_DURATION = 5000; // ms an image slide stays before auto-advancing

  function initRwIgWidget() {
    var widget = document.getElementById('rw-ig-widget');
    if (!widget) return;
    var pill = document.getElementById('rw-ig-pill');
    var closeBtn = document.getElementById('rw-ig-close');
    var panel = document.getElementById('rw-ig-panel');
    var slidesEl = document.getElementById('rw-ig-slides');
    if (!slidesEl) return;

    var slides = Array.prototype.slice.call(slidesEl.querySelectorAll('.rw-ig-slide'));
    var segmentFills = Array.prototype.slice.call(document.querySelectorAll('.rw-ig-segment-fill'));
    var segmentEls = Array.prototype.slice.call(document.querySelectorAll('.rw-ig-segment'));
    var total = slides.length;
    var currentIndex = 0;
    var embedsProcessed = false;
    var autoTimer = null;
    var scrollSyncTimer = null;
    var isProgrammaticScroll = false;

    function clearAutoTimer() {
      if (autoTimer) {
        clearTimeout(autoTimer);
        autoTimer = null;
      }
    }

    function pauseAllVideos() {
      slides.forEach(function (slide) {
        var v = slide.querySelector('video');
        if (v) v.pause();
      });
    }

    function updateSegments(index) {
      segmentEls.forEach(function (seg, i) {
        seg.classList.remove('is-done');
        var fill = segmentFills[i];
        if (!fill) return;
        fill.style.transition = 'none';
        if (i < index) {
          seg.classList.add('is-done');
        } else {
          fill.style.width = '0%';
        }
      });
    }

    function armAutoAdvance(index) {
      clearAutoTimer();
      var slide = slides[index];
      if (!slide) return;
      var type = slide.getAttribute('data-type');

      if (type === 'video') {
        var video = slide.querySelector('video');
        if (video) {
          video.currentTime = 0;
          video.play().catch(function () {});
          var onEnded = function () {
            video.removeEventListener('ended', onEnded);
            goTo(currentIndex + 1);
          };
          video.addEventListener('ended', onEnded);
        }
      } else if (type === 'image') {
        var fill = segmentFills[index];
        if (fill) {
          fill.style.transition = 'width ' + IMAGE_SLIDE_DURATION + 'ms linear';
          requestAnimationFrame(function () {
            fill.style.width = '100%';
          });
        }
        autoTimer = setTimeout(function () {
          goTo(currentIndex + 1);
        }, IMAGE_SLIDE_DURATION);
      }
      // type === 'embed': no auto-advance, duration is unknown/uncontrollable.
    }

    function goTo(index) {
      if (index < 0) index = 0;
      if (index >= total) {
        index = 0;
      }
      clearAutoTimer();
      pauseAllVideos();
      currentIndex = index;
      isProgrammaticScroll = true;
      var target = slides[index];
      if (target) {
        slidesEl.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }
      updateSegments(index);
      setTimeout(function () { isProgrammaticScroll = false; }, 350);
      armAutoAdvance(index);
    }

    function syncIndexFromScroll() {
      if (isProgrammaticScroll) return;
      var scrollLeft = slidesEl.scrollLeft;
      var width = slidesEl.clientWidth || 1;
      var nearest = Math.round(scrollLeft / width);
      if (nearest !== currentIndex && nearest >= 0 && nearest < total) {
        clearAutoTimer();
        pauseAllVideos();
        currentIndex = nearest;
        updateSegments(currentIndex);
        armAutoAdvance(currentIndex);
      }
    }

    slidesEl.addEventListener('scroll', function () {
      clearTimeout(scrollSyncTimer);
      scrollSyncTimer = setTimeout(syncIndexFromScroll, 120);
    });

    var prevZone = document.getElementById('rw-ig-tap-prev');
    var nextZone = document.getElementById('rw-ig-tap-next');
    if (prevZone) prevZone.addEventListener('click', function () { goTo(currentIndex - 1); });
    if (nextZone) nextZone.addEventListener('click', function () { goTo(currentIndex + 1); });

    function open() {
      widget.classList.add('is-open');
      pill.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      if (!embedsProcessed && window.instgrm) {
        window.instgrm.Embeds.process();
        embedsProcessed = true;
      }
      goTo(0);
    }

    function closePanel() {
      widget.classList.remove('is-open');
      pill.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      clearAutoTimer();
      pauseAllVideos();
    }

    function dismissWidget() {
      closePanel();
      widget.classList.add('is-dismissed');
    }

    pill.addEventListener('click', function () {
      widget.classList.contains('is-open') ? closePanel() : open();
    });
    closeBtn.addEventListener('click', dismissWidget);

    document.addEventListener('click', function (e) {
      if (widget.classList.contains('is-open') && !widget.contains(e.target)) closePanel();
    });

    updateSegments(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRwIgWidget);
  } else {
    initRwIgWidget();
  }
})();
